import React from 'react';
const groups = [{
  title: 'Product',
  links: ['Inventory recovery', 'Returns management', 'Recovery ledger', 'Integrations']
}, {
  title: 'Company',
  links: ['About', 'Careers', 'Press', 'Contact']
}, {
  title: 'Resources',
  links: ['Recovery guide', 'Case studies', 'Blog', 'Help center']
}];
export function Footer() {
  return <footer className="border-t border-ink/10 bg-cream" data-id="element-1312" data-mp="36pz9966ny5g3">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8" data-id="element-1313" data-mp="3ueiltxwqx4dz">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-1314" data-mp="3ucxs2ai99ph6">
          <div data-id="element-1315" data-mp="387clehl0xbk">
            <a href="#top" className="inline-block" aria-label="ManyCo.ai home" data-id="element-1316" data-mp="37xv6falryhh">
              <img src="https://cdn.magicpatterns.com/uploads/oywoASH6Re9P4rztZheujv/ManyCo_ai.svg" alt="ManyCo.ai" className="h-9 w-auto" data-id="element-1317" data-mp="3ldu4at858lwc" />
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink/60" data-id="element-1318" data-mp="2a19u3nmf7qxt">
              The recovery platform that turns excess and returned inventory back into cash — while
              protecting your brand.
            </p>
          </div>

          {groups.map(g => <div key={g.title} data-id="element-1319" data-mp="3gc0f1dfz7i4g">
              <h3 className="text-sm font-semibold text-ink" data-id="element-1320" data-mp="3gctr8txpeztz">{g.title}</h3>
              <ul className="mt-4 space-y-2.5" data-id="element-1321" data-mp="3v918pmhq9n5k">
                {g.links.map(l => <li key={l} data-id="element-1322" data-mp="3q725cclzmq8m">
                    <a href="#" className="text-sm text-ink/60 transition-colors hover:text-forest" data-id="element-1323" data-mp="3qazp90ge3ltk">
                      {l}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-ink/10 pt-6 text-sm text-ink/50 sm:flex-row sm:items-center" data-id="element-1324" data-mp="hrs9vnclsj9t">
          <p data-id="element-1325" data-mp="qthzqoqu7a5h">© {new Date().getFullYear()} manyco.ai — All rights reserved.</p>
          <div className="flex gap-6" data-id="element-1326" data-mp="qrfaw81f7n2c">
            <a href="#" className="transition-colors hover:text-ink" data-id="element-1327" data-mp="msg5ynfovqaw">Privacy</a>
            <a href="#" className="transition-colors hover:text-ink" data-id="element-1328" data-mp="tv4om5kz9a6l">Terms</a>
            <a href="#" className="transition-colors hover:text-ink" data-id="element-1329" data-mp="tt0a6tpgcss2">Security</a>
          </div>
        </div>
      </div>
    </footer>;
}